export default ({driver: {address_street2 = ''} = {}} = {}) => address_street2;
